import { switchLocalWorkspace } from "../offline/localWorkspace";

const CHANGE_EVENT = "billsarthi:full-offline-mode-change";

let enabled = false;
let initialized = false;
let unsubscribe = null;

const desktopApi = () =>
  typeof window !== "undefined" ? window.desktopOfflineMode : null;

const publish = (nextValue) => {
  enabled = nextValue === true;
  switchLocalWorkspace(enabled);
  window.dispatchEvent(new CustomEvent(CHANGE_EVENT, {
    detail: { enabled },
  }));
};

export const initializeFullOfflineMode = async () => {
  const api = desktopApi();
  if (!api || initialized) return enabled;
  initialized = true;
  unsubscribe = api.onChange((value) => publish(value?.enabled));
  const value = await api.get();
  publish(value?.enabled);
  return enabled;
};

export const isFullOfflineModeEnabled = () => enabled;

// Mutation handlers use the main process as the authority. The synchronous
// getter is for render decisions after initialization; it must not decide
// whether a destructive action is local-only.
export const getFullOfflineModeEnabled = async () => {
  const api = desktopApi();
  if (!api?.get) return enabled;
  try {
    const value = await api.get();
    const nextValue = value?.enabled === true;
    if (nextValue !== enabled) publish(nextValue);
    return nextValue;
  } catch {
    return enabled;
  }
};

export const setFullOfflineMode = async (nextValue) => {
  const api = desktopApi();
  if (!api) return { enabled: false };
  const value = await api.set(nextValue === true);
  publish(value?.enabled);
  return { enabled };
};

export const subscribeToFullOfflineMode = (callback) => {
  if (typeof window === "undefined") return () => {};
  const listener = (event) => callback(event.detail?.enabled === true);
  window.addEventListener(CHANGE_EVENT, listener);
  return () => window.removeEventListener(CHANGE_EVENT, listener);
};

export const disposeFullOfflineMode = () => {
  unsubscribe?.();
  unsubscribe = null;
  initialized = false;
};
